// @flow

import type { PaginationHeaders } from '@globalTypes';
import {
  DOCTOR_SEARCH_REQUEST,
  DOCTOR_SEARCHBAR_REQUEST,
  DOCTOR_SEARCH_REQUESTED,
  DOCTOR_SEARCHBAR_REQUESTED,
  DOCTOR_SEARCH_REQUESTED_ERROR,
  DOCTOR_SEARCH_RESET,
  PATIENT_SECOND_OPINION_BOOKING_REQUEST_DOCTORS
} from './constants';

import type {
  Action, Doctors, Facility, FacilityGroup, Photo
} from '../types';

export const requestDoctorList = (
  requestPayload: {
    pageNumber?: string,
    location?: string,
    department?: string,
    address_city?: string,
    dontScroll?: boolean,
    custom_per_page?: number,
    doctor_slugs?: Array<string>,
    doctor_ids?: Array<string>,
    facility_id?: string
  } = {}
): Action => ({
  type: DOCTOR_SEARCH_REQUEST,
  ...requestPayload
});

export const requestDoctorsDetails = (
  requestPayload: {
    pageNumber?: string,
    location?: string,
    department?: string,
    address_city?: string,
    dontScroll?: boolean,
    custom_per_page?: number,
    doctor_slugs?: Array<string>,
    doctor_ids?: Array<string>,
    facility_id?: string
  } = {}
): Action => ({
  type: PATIENT_SECOND_OPINION_BOOKING_REQUEST_DOCTORS,
  ...requestPayload
});

export const requestDoctorListSearchBar = (
  requestPayload: {
    pageNumber?: string,
    location?: string,
    department?: string,
    address_city?: string,
    name?: string
  } = {}
): Action => ({
  type: DOCTOR_SEARCHBAR_REQUEST,
  ...requestPayload
});

export const updateDoctorList = (
  data: Doctors,
  included: Array<FacilityGroup | Facility | Photo>,
  headers: PaginationHeaders
): Action => ({
  type: DOCTOR_SEARCH_REQUESTED,
  data,
  headers,
  included
});

export const updateDoctorListSearchBar = (
  data: Doctors,
  included: Array<FacilityGroup | Facility | Photo>,
  headers: PaginationHeaders
): Action => ({
  type: DOCTOR_SEARCHBAR_REQUESTED,
  data,
  headers,
  included
});

export const errorDoctorList = (error: Error): Action => ({
  type: DOCTOR_SEARCH_REQUESTED_ERROR,
  error
});

export const resetDoctorList = (): Action => ({
  type: DOCTOR_SEARCH_RESET
});
